import VueRouter from "vue-router";

import Palettes from "./Domain/Palette/Views/Palettes";
import Colors   from "./Domain/Palette/Views/Colors";
import Code     from "./Domain/Code/Views/Code";
import Notes    from "./Domain/Palette/Views/Notes";
import Share    from "./Domain/Palette/Views/Share";
import NotFound from "./App/Views/NotFound";

import EditProfile from "./Domain/User/Views/EditProfile";

import ForgotPassword from "./Domain/User/Views/ForgotPassword";
import ResetPassword  from "./Domain/User/Views/Auth/ResetPassword";

const router = new VueRouter({
    mode  : "history",
    routes: [
        {
            path     : '/palettes',
            name     : 'palettes',
            component: Palettes
        },
        {
            path     : '/colors',
            name     : 'colors',
            component: Colors
        },
        {
            path     : '/code',
            name     : 'code',
            component: Code
        },
        {
            path     : '/notes',
            name     : 'notes',
            component: Notes
        },
        {
            path     : '/profile/edit',
            name     : 'edit-profile',
            component: EditProfile,
        },
        {
            path     : '/password/reset',
            name     : 'reset-password',
            component: ForgotPassword,
        },
        {
            path     : '/password/reset/:token',
            name     : 'reset-password-form',
            component: ResetPassword,
        },
        {
            path     : '/share/:user_id?/:share_token?',
            name     : 'share',
            component: Share,
        },
        {
            path     : '/404',
            name     : '404',
            component: NotFound,
        },
        {
            path: '*',
            redirect: '404',
        }
    ],
});

export default router;
